import { EXPORT_SIGNATURE_HEADERS } from '@/modules/entity-management/utils/normalize-export-csv/exportCsvConstants';

const SIGNATURE_HEADER_SET = new Set(EXPORT_SIGNATURE_HEADERS);

/**
 * Detects a "Download Data" export CSV by the presence of any baseline column
 * that never appears in the bulk-import schema. These cannot collide with a
 * valid import file, so there are no false positives against real import CSVs.
 */
export function isEntityExportCsv(header: string[]): boolean {
    return header.some((label) => SIGNATURE_HEADER_SET.has(label.trim()));
}
